<template>
    <div class="container">
      <BaseFrame
        submitText='提交'
        @submit='submitActivityList'
        @clear="cancelClick"
        clearText=''
        :isShowBtn='true'
      >
      <div slot="content">
        <lk-card title="活动详情" class="mb16">
          <div class="btnArea">
            <lk-button type="primary" @click="clickUpload">导入活动内容</lk-button>
            <span class="font14"><a @click="downLoad('https://linkdoc-erp.oss-cn-beijing.aliyuncs.com/erp-uid-3063/932210181926.xlsx?Expires=3221292416&OSSAccessKeyId=LTAIhQ088Y2NYQem&Signature=ozompXnSIEzLNS7mHSScCnwPfIE%3D', '营销活动批量导入模板.xlsx')"> &nbsp; &nbsp;下载导入模板</a></span>
            <!-- TODO:测试环境存在兼容性问题，暂时留着 -->
            <!-- <span class="font14"><a href='https://linkdoc-erp.oss-cn-beijing.aliyuncs.com/erp-uid-3063/932210181926.xlsx?Expires=3221292416&OSSAccessKeyId=LTAIhQ088Y2NYQem&Signature=ozompXnSIEzLNS7mHSScCnwPfIE%3D'> &nbsp; &nbsp;下载导入模板</a></span> -->
        </div>
        <div class="tableArea">
          <lk-table :columns='columns' :data='dataList' border ></lk-table>
        </div>
        <lk-Page
          class="pages"
          show-sizer
          show-elevator
          show-total
          :page-size="size"
          @on-page-size-change='handlePageSize'
          @on-change='handlePage'
          :total = 'count'
          :page-size-opts='[20,30,50,100]'
          :current="page"
        ></lk-Page>
      </lk-card>
      <DTPListModal v-model="showErrorAlert" :noCancel='true' @confirm="hiddenErrorView" :list='errorList' subTitle='导入失败' title="导入校验" type='alert'></DTPListModal>

      <!-- // 重复提交 -->
      <lk-modal v-model="showReUploadAlert"
        footer-hide='true'
        title="导入活动内容"
        width="400"
        @on-cancel="reCancel"
      >
        <div class="reContainer">
          <div class="subTitle">
            <span
                :class="{
                    'iconfont':true,
                    'alert':true,
                }">&#xe613;
            </span>
            <span class="reSubmitWornWord">重新导入活动将清空已导入内容，是否确认？</span>
          </div>
          <div class="reButtons">
            <lk-button type='primary' @click="reConfirm">确定</lk-button>
            <lk-button @click="reCancel" class="cancel">取消</lk-button>
          </div>
        </div>
      </lk-modal>

      <!-- // 导入模板 -->
      <lk-modal v-model="showUploadAlert"
        footer-hide='true'
        title="导入活动内容"
        width="400"
        @on-cancel="upCancel"
      >
        <div class="uploadContainer">
          <div class="subTitle">
            <span class="word">导入模板：</span>
          </div>
          <div class="uploadContent">
            <div class="uploader" @click="$refs.file.click()">
              <input type="file" ref="file" @change="fileReader" v-show="false">
              <p>
                <lk-icon type="ios-cloud-upload-outline" size="16"></lk-icon>点击上传
              </p>
            </div>
          <div style="margin-top:12px;" v-if="this.file">
            {{`上传的文件是:${this.file.name || ''}`}}
          </div>
            <span class="font14">请先<a @click="downLoad('https://linkdoc-erp.oss-cn-beijing.aliyuncs.com/erp-uid-3063/932210181926.xlsx?Expires=3221292416&OSSAccessKeyId=LTAIhQ088Y2NYQem&Signature=ozompXnSIEzLNS7mHSScCnwPfIE%3D', '营销活动批量导入模板.xlsx')">下载导入模板</a> ，编辑无误后上传文件</span>
            <!-- TODO:测试环境存在兼容性问题，暂时留着 -->
            <!-- <span class="font14">请先<a href='https://linkdoc-erp.oss-cn-beijing.aliyuncs.com/erp-uid-3063/932210181926.xlsx?Expires=3221292416&OSSAccessKeyId=LTAIhQ088Y2NYQem&Signature=ozompXnSIEzLNS7mHSScCnwPfIE%3D'>下载导入模板</a> ，编辑无误后上传文件</span> -->
          </div>
          <div class="buttons">
            <lk-button type='primary' class="cancel" @click="importActivity" :disabled="!file">确定上传</lk-button>
            <lk-button @click="upCancel" >取消</lk-button>
          </div>
        </div>
      </lk-modal>
      </div>
      </BaseFrame>
    </div>
  </template>
<script>
import marketing from '@/services/marketing';
import Axios from 'axios';
import utils from '../../../libs/utils';
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import DTPListModal from '../../../components/DTPListModal.vue';

export default {
  components: {
    BaseFrame,
    DTPListModal,
    marketing,
    utils,
  },
  data() {
    return {
      errorList: [],
      showErrorAlert: false,
      showReUploadAlert: false,
      showUploadAlert: false,
      isShowImport: false,
      size: 20,
      page: 1,
      count: 0,
      loading: false,
      dataList: [],
      importKey: '',
      file: '',
      columns: [
        {
          type: 'index',
          title: '行号',
          minWidth: 116,
        },
        {
          title: '活动名称',
          key: 'promoteSaleName',
          minWidth: 116,
        },
        {
          title: '活动门店',
          key: 'storeName',
          minWidth: 116,
        },
        {
          title: '活动范围',
          key: 'promoteSaleType',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '统计类型',
          key: 'promoteSaleStatisticalType',
          minWidth: 116,
        },
        {
          title: '活动开始时间',
          key: 'promoteSaleTimeBegin',
          minWidth: 116,
          // render: (h, { row }) => h('span', utils.formatTime(row.promoteSaleTimeBegin)),
        },
        {
          title: '活动结束时间',
          key: 'promoteSaleTimeEnd',
          minWidth: 116,
          // render: (h, { row }) => h('span', utils.formatTime(row.promoteSaleTimeEnd)),
        },
        {
          title: '管理类型',
          key: 'promoteSaleManagementType',
          minWidth: 116,
        },
        {
          title: '活动商品',
          key: 'promoteSalesGoodsSericalCode',
          minWidth: 116,
        },
        {
          title: '通用名',
          key: 'approvedDrugNames',
          minWidth: 116,
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '批次号',
          key: 'promoteSalesGoodsBatchSeq',
          minWidth: 116,
        },
        {
          title: '折扣规则',
          key: 'promoteRuleDiscountRuleDesc',
          minWidth: 300,
        },
        {
          title: '折扣说明',
          key: 'promoteSaleDescription',
          minWidth: 250,
        },
      ],
    };
  },
  methods: {
    cancelClick() {
      this.$router.go(-1);
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    hiddenErrorView() {
      this.showErrorAlert = false;
    },
    clickUpload() {
      this.showUploadAlert = true;
    },
    upCancel() {
      this.file = '';
      this.showUploadAlert = false;
    },
    fileReader(e) {
      this.file = e.target.files[0];
      e.target.value = null;
    },
    importActivity() { // 上传
      this.showUploadAlert = false;
      if (this.importKey) {
        this.showReUploadAlert = true;
        return;
      }
      this.uploadFile();
    },
    reConfirm() {
      this.showReUploadAlert = false;
      this.uploadFile();
    },
    reCancel() {
      this.file = '';
      this.showReUploadAlert = false;
    },
    uploadFile() {
      var form = new FormData();
      form.append('file', this.file);
      marketing.importActivity(form).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('导入成功');
          this.importKey = res.data.data;
          this.getData();
        } else if (res.data.status == 60036) {
          this.errorList = res.data.data;
          this.showErrorAlert = true;
        } else {
          utils.handleError(res.data.error);
        }
        this.file = '';
      }).catch((err) => {
        this.file = '';
        if (err.status == 60036) {
          this.errorList = err.data;
          this.showErrorAlert = true;
        } else {
          utils.handleError(err);
        }
      });
    },
    getData() { // 获取数据
      const listParams = {
        importKey: this.importKey,
        page: this.page,
        size: this.size,
      };
      marketing.getActivityList(listParams).then((res) => {
        if (res.data.status === 200) {
          this.dataList = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    submitActivityList() { // 提交
      const listParams = { importKey: this.importKey };
      marketing.submitActivityList(listParams).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('创建成功');
          this.$router.go(-1);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    downLoad(url, name) {
      Axios.get(url, {
        responseType: 'blob',
      }).then((res) => {
        if (!res) {
          this.$Message.error('下载模版失败，请稍后重试');
        }
        utils.downFile(res.data, name);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    // this.pageType = this.pageTypes[this.$route.name];
  },
};
</script>
<style lang="less">
  .pages{
  margin-top: 16px;
  text-align: right
}
.btnArea {
    margin-bottom: 10px;
  }
.reContainer{
  position: relative;
  height: 70px;
}
.buttons{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 136px;
  .cancel{
    margin-right: 16px
  }
}
.title {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .word{
    font-size: 14px;
    color: rgba(0,0,0,0.75);
    margin-left: 8px
  }
}
.subTitle{
  display: flex;
  align-items: left;
  .icon{
    margin-right: 16px;
    color: #1890FF
  }
  .alert{
    color: orange;
  }
  .info{
    color: #1890FF
    // color: #FF4D07
  }
  .word{
    font-size: 12px;
    color: rgba(0,0,0,0.75);
    margin-left: 8px
  }
}
.uploadContainer {
  position: relative;
  height: 120px;
}
.uploadContent{
  display: flex;
  justify-content: flex-start;
  position: absolute;
  flex-direction: column;
  top: 1px;
  left: 80px;
}
.blue {
  color: #1890FF;
}
.font14 {
  font-size: 12px;
}
.uploader {
    height: 28px;
    width: 87px;
    border: 1px dashed #dedede;
    text-align: center;
    position: relative;
    cursor: pointer;
    line-height: 1.2;
    p {
      line-height: 28px;
      font-size: 12px
    }
  }
  .reButtons{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 136px;
    .cancel{
      margin-left: 10px
    }
  }
  .reSubmitWornWord{
    font-size: 12px;
    color: rgba(0,0,0,0.75);
    margin-left: 8px;
    margin-top: 3px;
  }
</style>
